import Constants from 'expo-constants'

export const WS_URL = Constants.manifest.extra.WS_URL
